import api from './api';

export interface QuizSession {
  id: number;
  student: number;
  student_name: string;
  name: string;
  assigned_date: string;
  created_by: number;
  created_by_name: string;
  quiz_count: number;
  is_active: boolean;
  is_available: boolean;
}

class QuizSessionService {
  async getAll(params?: any): Promise<QuizSession[]> {
    const response = await api.get('/quiz-sessions/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getByStudent(studentId: number): Promise<QuizSession[]> {
    const response = await api.get('/quiz-sessions/', {
      params: { student: studentId }
    });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getSession(id: number): Promise<QuizSession> {
    const response = await api.get(`/quiz-sessions/${id}/`);
    return response.data;
  }

  async create(data: Partial<QuizSession>): Promise<QuizSession> {
    const response = await api.post('/quiz-sessions/', data);
    return response.data;
  }

  async update(id: number, data: Partial<QuizSession>): Promise<QuizSession> {
    const response = await api.patch(`/quiz-sessions/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/quiz-sessions/${id}/`);
  }

  async toggleActive(id: number): Promise<QuizSession> {
    const response = await api.post(`/quiz-sessions/${id}/toggle_active/`);
    return response.data;
  }

  async toggleAvailable(id: number): Promise<QuizSession> {
    const response = await api.post(`/quiz-sessions/${id}/toggle_available/`);
    return response.data;
  }

  async getAttemptsTimeline(dateFrom: string, dateTo: string): Promise<{student: number, completed_date: string, was_correct: boolean}[]> {
    const response = await api.get('/quiz-sessions/attempts_timeline/', {
      params: { date_from: dateFrom, date_to: dateTo }
    });
    return response.data;
  }
}

const quizSessionService = new QuizSessionService();
export default quizSessionService;
